export enum PERMISSIONS {
  AGENT_MANAGEMENT_PERFORMANCE_READ = 'sv.agent.management.performance.read',
  TASK_POOL_UPLOAD_TASK_WRITE = 'sv.task.pool.taskUpload.write',
  TASK_POOL_UPLOAD_TASK_READ = 'sv.task.pool.taskUpload.read'
}
